import appBooking from "../../views/appBooking.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("booking", {
    url: "booking/:id",
    parent: "app",
    views: {
      view: {
        template: appBooking,
      },
    },
    data: { title: "Booking" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/booking/booking.urls.js